exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1VXgdovKXaunoC{max-height:0;opacity:.01;transition-property:opacity,max-height;transition-duration:.15s;transition-timing-function:ease-out,linear}._3NdPJic6OR8wdi,.b6oU-1arBolXlk{max-height:300px;opacity:1}.b6oU-1arBolXlk{transition-property:opacity,max-height;transition-duration:.2s;transition-timing-function:ease-out,linear}._23I4gPZCUuJyER{max-height:0;opacity:.01}", ""]);

// exports
exports.locals = {
	"revealExpandStart": "_1VXgdovKXaunoC",
	"revealExpandEnd": "_3NdPJic6OR8wdi",
	"fadeCollapseStart": "b6oU-1arBolXlk",
	"fadeCollapseEnd": "_23I4gPZCUuJyER"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/dismiss-animation.less
// module id = wMq7
// module chunks = 24